import '@boomi/exosphere/dist/styles.css';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from '../js/store/store';
import Root from './components/Root';
import { NotificationsProvider } from './components/notifications/NotificationProvider';

// Need to import exosphere icons separately
// https://exosphere.boomi.com/?path=/docs/miscellaneous-migrate-to-7-x-x--overview#migrating-to-7xx
import '@boomi/exosphere/dist/icon.js';

window.React = React;

const root = createRoot(document.getElementById('root') as Element);
root.render(
    <StrictMode>
        <BrowserRouter>
            <Provider store={store}>
                <NotificationsProvider>
                    <Root />
                </NotificationsProvider>
            </Provider>
        </BrowserRouter>
    </StrictMode>,
);

export default root;
